var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"streak-count"},[_c('div',{staticClass:"icon-wrap"},[_c('bolt-icon')],1),_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.count)+" day"),_c('br'),_vm._v("streak")])])}
var staticRenderFns = []

export { render, staticRenderFns }